import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Tareas pendientes
    pendingTask: {
      tableData: [],
      totalPendingTask: 0
    },
    queryPendingTask: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersPendingTask: [],

    // Usuarios
    usersPendingTask: {
      tableData: [],
      totalUsers: 0
    },

    // Datos Select Filtros Tareas pendientes
    optionsFilterBuyerPendingTask: [],
    optionsFilterSellerPendingTask: [],
    optionsFilterStatusPendingTask: [],
    optionsFilterInternalStatusPendingTask: [],
    optionsFilterCategoriesPendingTask: [],

    invoiceNoteIdsPendingTask: [], // Factura o facturas seleccionadas,se utiliza en la creación de caratula
    projectNamependingTask: '',
    hasCoverPendingTask: false, // Flag que indica que existe la caratula
    radioOption: null

  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Tareas pendientes
    isShowBuyerPendingTask: false,
    isShowBuyerCentersPendingTask: false,
    isShowSellerPendingTask: true,
    isShowNumPendingTask: true, // Numero de factura
    isShowDateIssuePendingTask: true, // F.emision
    isShowRegisterNumberPendingTask: true, // Nº Registro
    isShowDateCreationPendingTask: true, // F.Registro
    isShowImportPendingTask: true,
    isShowCurrencyPendingTask: false,
    isShowStatusPendingTask: true,
    isShowReceptionMethodPendingTask: true,
    isShowIsPendingTask: true,
    isShowStatusInternalPendingTask: true
  }
  return local
}
function setByUserLocalPend () {
  const local = {
    // Columnas Tabla Tareas pendientes
    isShowBuyerPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowBuyerPendingTask,
    isShowBuyerCentersPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowBuyerCentersPendingTask,
    isShowSellerPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowSellerPendingTask,
    isShowNumPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowNumPendingTask, // Numero de factura
    isShowDateIssuePendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowDateIssuePendingTask, // F.emision
    isShowRegisterNumberPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowRegisterNumberPendingTask, // Nº Registro
    isShowDateCreationPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowDateCreationPendingTask, // F.Registro
    isShowImportPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowImportPendingTask,
    isShowCurrencyPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowCurrencyPendingTask,
    isShowStatusPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowStatusPendingTask,
    isShowReceptionMethodPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowReceptionMethodPendingTask,
    isShowIsPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowIsPendingTask,
    isShowStatusInternalPendingTask: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).tareaspendientes.isShowStatusInternalPendingTask
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Tareas pendientes
    isShowBuyerPendingTask: false,
    isShowBuyerCentersPendingTask: false,
    isShowSellerPendingTask: true,
    isShowNumPendingTask: true, // Numero de factura
    isShowDateIssuePendingTask: true, // F.emision
    isShowRegisterNumberPendingTask: true, // Nº Registro
    isShowDateCreationPendingTask: true, // F.Registro
    isShowImportPendingTask: true,
    isShowCurrencyPendingTask: false,
    isShowStatusPendingTask: true,
    isShowReceptionMethodPendingTask: true,
    isShowIsPendingTask: true,
    isShowStatusInternalPendingTask: true
  },

  session: initSession()
}

// getters
const getters = {
  // Usuarios
  usersPendingTask: state => {
    return state.session.usersPendingTask
  },

  // Datos Tabla Tareas pendientes
  pendingTask: state => {
    return state.session.pendingTask
  },
  queryPendingTask: state => {
    return state.session.queryPendingTask
  },
  listSelectedFiltersPendingTask: state => {
    return state.session.listSelectedFiltersPendingTask
  },

  // Datos Select Filtros Tareas pendientes
  optionsFilterBuyerPendingTask: state => {
    return state.session.optionsFilterBuyerPendingTask
  },
  optionsFilterSellerPendingTask: state => {
    return state.session.optionsFilterSellerPendingTask
  },
  optionsFilterStatusPendingTask: state => {
    return state.session.optionsFilterStatusPendingTask
  },
  optionsFilterInternalStatusPendingTask: state => {
    return state.session.optionsFilterInternalStatusPendingTask
  },
  optionsFilterCategoriesPendingTask: state => {
    return state.session.optionsFilterCategoriesPendingTask
  },

  // Factura o Facturas en Session
  invoiceNoteIdsPendingTask: state => {
    return state.session.invoiceNoteIdsPendingTask
  },

  projectNamependingTask: state => {
    return state.session.projectNamependingTask
  },

  radioOption: state => {
    return state.session.radioOption
  },
  // Carátula en sesión
  hasCoverPendingTask: state => {
    return state.session.hasCoverPendingTask
  }, 

  // Columnas Tabla Tareas pendientes
  isShowBuyerPendingTask: state => {
    return state.local.isShowBuyerPendingTask
  },
  isShowBuyerCentersPendingTask: state => {
    return state.local.isShowBuyerCentersPendingTask
  },
  isShowSellerPendingTask: state => {
    return state.local.isShowSellerPendingTask
  },
  isShowNumPendingTask: state => {
    return state.local.isShowNumPendingTask
  },
  isShowDateIssuePendingTask: state => {
    return state.local.isShowDateIssuePendingTask
  },
  isShowDateCreationPendingTask: state => {
    return state.local.isShowDateCreationPendingTask
  },
  isShowImportPendingTask: state => {
    return state.local.isShowImportPendingTask
  },
  isShowCurrencyPendingTask: state => {
    return state.local.isShowCurrencyPendingTask
  },
  isShowStatusPendingTask: state => {
    return state.local.isShowStatusPendingTask
  },
  isShowReceptionMethodPendingTask: state => {
    return state.local.isShowReceptionMethodPendingTask
  },
  isShowIsPendingTask: state => {
    return state.local.isShowIsPendingTask
  },
  isShowStatusInternalPendingTask: state => {
    return state.local.isShowStatusInternalPendingTask
  },
  isShowRegisterNumberPendingTask: state => {
    return state.local.isShowRegisterNumberPendingTask
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNamePend ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalPend()
    }
  },
  async isNewVersionTareasPendientesLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.tareaspendientes)
    return isnew
  },

  /* TAREAS_PENDIENTES */
  /**
  * Servicio para traer las tareas pendientes .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getPendingTask ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask',
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE getPendingTask:: ', response)

      commit('PENDING_TASK_STATE', {
        tableData: response.data.content,
        totalPendingTask: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de una tarea pendiente
  async getPendingTaskById ({ commit, rootState }, invoiceID) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + invoiceID
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los estados de las tareas pendientes
   */
  async getOptionsFilterStatusPendingTask ({ commit, state }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/pendingtaskstatus',
        params: {
          projectId: data
        }
      })

      console.log('SELECT getOptionsFilterStatusPendingTask: ', response)
      const optionsFilterStatusPendingTask = response.data
      commit('OPTIONS_FILTERS_STATUS_PENDING_TASK', optionsFilterStatusPendingTask)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      console.log('Status: ' + optionsFilterStatusPendingTask)
      return optionsFilterStatusPendingTask
    } catch (error) {
      console.log('Status pending task: ', error)
      throw error.response
    }
  },

  /**
  * Servicio para obtener los estados internos de una factura
  */
  async getOptionsFilterStatusInternalPendingTask ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/statusinternal'
      })

      console.log('SELECT getOptionsFilterStatusInternalPendingTask: ', response)
      const optionsFilterInternalStatusPendingTask = response.data
      commit('OPTIONS_FILTER_INTERNAL_STATUS_PENDING_TASK', optionsFilterInternalStatusPendingTask)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterInternalStatusPendingTask
    } catch (error) {
      console.log('Status internal pending task : ', error)
      throw error.response
    }
  },

  /**
  * Servicio para obtener las categorias
  */
  async getOptionsCategories ({ commit, state }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/categories',
        params: {
          projectId: data
        }
      })

      const optionsFilterCategories = response.data
      commit('OPTIONS_FILTER_CATEGORIES_PENDING_TASK', optionsFilterCategories)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterCategories
    } catch (error) {
      console.log('Categories : ', error)
      throw error.response
    }
  },

  /**
  * Servicio para obtener los estados de de configuración de proyecto
  */
  async getStatusHermesPendingTask ({ commit, state }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/projectstatusconfig',
        params: {
          projectId: data
        }
      })

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      console.log('Status Hermes: ' + response.data)
      return response.data
    } catch (error) {
      console.log('Categories : ', error)
      throw error.response
    }
  },

  /**
    * Servicio para descargar pdf de una tarea pendiente
    * @param {*} invoiceId
    */
  async downloadPendingTaskPdf ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceId + '/pdf',
        responseType: 'blob'
      })

      console.log('RESPONSE downloadPendingTaskPdf:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'factura.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para descargar Original Firmado de una Factura
   * @param {*} invoiceNoteId
   */
  async downloadInvoiceSignedOriginalPendingTask ({
    commit, state
  }, invoiceNoteId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + invoiceNoteId + '/signedoriginal',
        responseType: 'blob'
      })

      console.log('RESPONSE downloadInvoiceSignedOriginalPendingTask:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'factura-original'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los eventos
   *  @param {*} invoiceId
   */
  async getEvents ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceId + '/event'
      })

      console.log('RESPONSE getEvents:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar ZIP de todos los PDF de las facturas de tareas pendientes
     * @param {*} invoiceIds
     */
  async downloadInvoicePdfMultiple ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/pdf',
        params: {
          invoiceNoteId: params.invoiceIds
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      console.log('RESPONSE downloadInvoicePdfMultiple:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pdfs-recadv.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para descargar ZIP de todos los Originales Firmados de las Facturas de las tareas pendientes
  * @param {*} invoiceNoteId
  */
  async downloadMultiInvoiceSignedOriginal ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/signedoriginal',
        params: {
          invoiceNoteId: params.invoiceIds
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      console.log('RESPONSE downloadMultiInvoiceSignedOriginal:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'originales-firmados-facturas.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getInvoiceNoteAttachmentsPendingTask ({ commit, state }, invoiceNoteId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + invoiceNoteId + '/attachment'
      })

      console.log('RESPONSE getInvoiceNoteAttachmentsPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar los adjuntos a la Factura
     * @param {*} params
     */
  async downloadInvoiceNoteAttachmentPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/attachment/' + params.attachmentId,
        responseType: 'blob'
      })

      console.log('RESPONSE downloadInvoiceNoteAttachmentPendingTask:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'adjunto-factura'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para eliminar adjunto de la Factura
  * @param {*} params
  */
  async removeInvoiceNoteAttachmentPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/attachment/' + params.attachmentId
      })

      console.log('RESPONSE removeInvoiceNoteAttachmentPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      console.log('removeInvoiceNoteAttachmentPendingTask: ', response)

      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para añadir adjuntos a una Factura
  * @param {*} params
  */
  async addInvoiceNoteAttachmentPendingTask ({ commit, state }, params) {
    const formData = new FormData()
    formData.append('attachment', params.attachment.raw)
    formData.append('hidden', params.hidden)
    console.log('params: ', params)
    console.log('formData: ', formData)
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/attachment',
        data: formData
      })

      console.log('RESPONSE addInvoiceNoteAttachmentPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async addInvoiceNoteApprovalParameterPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/approvalParameter',
        data: {
          invoiceNoteId: params.invoiceNoteId,
          code: params.code,
          value: params.value,
          numLine: params.numLine
        }
      })
      console.log('RESPONSE addInvoiceNoteApprovalParameterPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
  * Servicio para traer los campos adicionales para el flujo de aprobacion en primer nivel de una Factura
  * @param {*} invoiceNoteId
  */
  async getInvoiceNoteApprovalParametersPendingTask ({ commit, state }, invoiceNoteId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + invoiceNoteId + '/approvalParameters'
      })
      console.log('RESPONSE getInvoiceNoteApprovalParametersPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async removeInvoiceNoteApprovalParameterPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/approvalParameter',
        data: {
          invoiceNoteId: params.invoiceNoteId,
          code: params.code,
          value: params.value,
          numLine: params.numLine
        }
      })

      console.log('RESPONSE removeInvoiceNoteApprovalParameterPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      console.log('removeInvoiceNoteApprovalParameterPendingTask: ', response)

      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para traer la notas internas de una Factura
  * @param {*} invoiceNoteId
  */
  async getInvoiceNoteInternalPendingTask ({ commit, state }, invoiceNoteId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + invoiceNoteId + '/internalnote'
      })

      console.log('RESPONSE getInvoiceNoteInternalPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   /**
   * Servicio para llenar Select de
   * Documento de factura dado el formato.
   */
   async getSendManualConfig ({
    commit, rootState
  }, dat) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/pendingtask/sendManualConfig/' + dat.idProject,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const documentProjectConf = response.data

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return documentProjectConf
    } catch (error) {
      console.log('ERROR getOptionsInvoiceDocumentByFormat --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para modificar las notas internas de una Factura
   * @param {*} params
   */
  async modifyInvoiceNoteInternalNotesPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceNoteId + '/internalnote',
        data: {
          internalNotes: params.internalNotes
        }
      })
      console.log('RESPONSE modifyInvoiceNoteInternalNotesPendingTask:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para mandar factura/s a Sap
   * @param {*} params
   */
  async sendToSap ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/sap',
        params: {
          invoiceNoteId: params.invoiceIds
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE sendToSap:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para mandar factura a propuesta de pago
   * @param {*} params
   */
  async sendPaymentProposal ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/paymentproposal',
        params: {
          invoiceNoteId: params.invoiceIds
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE sendPaymentProposal:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para cargar una factura de propuesta de pago
   * @param {*} params
   */
  async getPaymentProposal ({ commit, state }, invoiceId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/pendingtask/' + invoiceId + '/paymentproposal'
      })

      console.log('RESPONSE getPaymentProposal:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para rechazar una factura
   * @param {*} params
   */
  async rejectedInvoice ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/' + params.invoiceNoteId + '/rejected',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          categoryId: params.categoryId,
          motive: params.motive
        }
      })

      console.log('RESPONSE rejectedInvoice:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para aprobar o enviar una factura en el flujo de aprobación por niveles
   * @param {*} params
   */
  async sendApproveInvoice ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/' + params.invoiceNoteId + '/approve',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          categoryId: params.categoryId,
          motive: params.motive
        }
      })
      console.log('RESPONSE rejectedInvoice:: ', response)
      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para crear o reiniciar caratulas
   * @param {*} params
   */
  async createCover ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/cover',
        data: {
          actionType: params.actionType,
          // projectId:localproject
          invoiceAttachmentCategoryId: params.invoiceAttachmentCategoryId,
          invoiceNoteId: params.invoiceNoteId
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE createCover:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eviar factura/s a firma
   * @param {*} params
   */
  async sendSignature ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/signature',
        data: {
          username: params.username,
          // projectId:localproject
          invoiceAttachmentCategoryId: params.invoiceAttachmentCategoryId,
          invoiceNoteId: params.invoiceNoteId
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE sendSignature:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eviar factura/s a visto bueno
   * @param {*} params
   */
  async sendAprroval ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/pendingtask/approval', // cambiar approval (doble p) cuando apuntemos al backend nuevo
        data: {
          username: params.username,
          invoiceAttachmentCategoryId: params.invoiceAttachmentCategoryId,
          invoiceNoteId: params.invoiceNoteId
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE sendSignature:: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /*
  * Servicio para traer los usuarios del sistema en el envio a firma y visto buenos.
  *
  */
  async getUsersPendingTask ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'pendingtask/users',
        params: params
      })

      console.log('RESPONSE getUsersPendingTask:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      commit('PENDING_TASK_USERS_STATE', {
        tableData: response.data.content,
        totalUsers: response.data.totalElements
      })
      return response
    } catch (error) {
      console.log('getUsers: ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para Exportar Todas las facturas  a CSV
     */
  async downloadCsvPendingTask ({ commit, rootState }, params) {
    try {
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/csv',
        params: params,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        },
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob'
      })

      console.log('RESPONSE downloadCsv:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'invoices.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para modificar el estado de una tarea pendiente
  * @param {*} params
  */
  async modifyStatusHermesPendingTask ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/' + params.invoiceId + '/status',
        data: {
          nextStatusId: params.statusId,
          observations: params.observations,
          categories: params.categories
        }
      })

      console.log('RESPONSE modifyStatusHermesPendingTask:: ', response)
      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async addBuyerCenter ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/pendingtask/addBuyerCenter/' + params.invoiceId + '/' + params.buyerCenterId,
      })

      console.log('RESPONSE addBuyerCenter:: ', response)
      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Usuarios
  usersPendingTaskState: ({ commit }, payload) => {
    commit('PENDING_TASK_USERS_STATE', payload)
  },
  // Datos Tabla Tareas pendientes
  pendingTaskState: ({ commit }, payload) => {
    commit('PENDING_TASK_STATE', payload)
  },
  queryPendingTaskState: ({ commit }, payload) => {
    commit('QUERY_PENDING_TASK_STATE', payload)
  },
  listSelectedFiltersPendingTaskState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_PENDING_TASK_STATE', payload)
  },

  // Datos Select Filtros Tareas pendientes
  optionsFilterBuyerPendingTaskState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_PENDING_TASK', payload)
  },
  optionsFilterSellerPendingTaskState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_PENDING_TASK', payload)
  },
  optionsFilterStatusPendingTaskState: ({ commit }, payload) => {
    commit('OPTIONS_FILTERS_STATUS_PENDING_TASK', payload)
  },
  optionsFilterInternalStatusPendingTaskState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_INTERNAL_STATUS_PENDING_TASK', payload)
  },
  optionsFilterCategoriesPendingTaskState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CATEGORIES_PENDING_TASK', payload)
  },
  radioOptionState: ({ commit }, payload) => {
    commit('RADIO_OPTION_PENDING_TASK', payload)
  },
  

  // Factura o Facturas en Session
  invoiceNoteIdsPendingTaskState: ({ commit }, payload) => {
    commit('INVOICE_NOTE_IDS_STATE', payload)
  },
  projectNamependingTaskState: ({ commit }, payload) => {
    commit('PROJECT_NAME_PENDING_STATE', payload)
  },
  // Carátula en sesión
  hasCoverPendingTaskState: ({ commit }, payload) => {
    commit('HAS_COVER_STATE', payload)
  },
  // Columnas Tabla Tareas pendientes
  isShowBuyerPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_PENDING_TASK', payload)
  },
  isShowBuyerCentersPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_CENTERS_PENDING_TASK', payload)
  },
  isShowSellerPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_PENDING_TASK', payload)
  },
  isShowNumPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_PENDING_TASK', payload)
  },
  isShowDateIssuePendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_PENDING_TASK', payload)
  },
  isShowDateCreationPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_PENDING_TASK', payload)
  },
  isShowImportPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_IMPORT_PENDING_TASK', payload)
  },
  isShowCurrencyPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_CURRENCY_PENDING_TASK', payload)
  },
  isShowStatusPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_PENDING_TASK', payload)
  },
  isShowReceptionMethodPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEPTION_METHOD_PENDING_TASK', payload)
  },
  isShowIsPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_IS_PENDING_TASK', payload)
  },
  isShowStatusInternalPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_INTERNAL_PENDING_TASK', payload)
  },
  isShowRegisterNumberPendingTaskAction: ({ commit }, payload) => {
    commit('IS_SHOW_REGISTER_NUMBER_PENDING_TASK', payload)
  }
}

// mutations
const mutations = {
  resetSessionTareasPendientes (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  pendingTaskDatesSuperAdmin (state) {
    state.session.queryPendingTask.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Usuarios
  'PENDING_TASK_USERS_STATE' (state, payload) {
    state.session.usersPendingTask = payload
  },

  // Tareas pendientes
  'PENDING_TASK_STATE' (state, payload) {
    state.session.pendingTask = payload
  },
  'QUERY_PENDING_TASK_STATE' (state, payload) {
    state.session.queryPendingTask = payload
  },
  'LIST_SELECTED_FILTERS_PENDING_TASK_STATE' (state, payload) {
    state.session.listSelectedFiltersPendingTask = payload
  },

  // Datos Select Filtros Tareas pendientes
  'OPTIONS_FILTER_BUYER_PENDING_TASK' (state, payload) {
    state.session.optionsFilterBuyerPendingTask = payload
  },
  'OPTIONS_FILTER_SELLER_PENDING_TASK' (state, payload) {
    state.session.optionsFilterSellerPendingTask = payload
  },
  'OPTIONS_FILTERS_STATUS_PENDING_TASK' (state, payload) {
    state.session.optionsFilterStatusPendingTask = payload
  },
  'OPTIONS_FILTER_INTERNAL_STATUS_PENDING_TASK' (state, payload) {
    state.session.optionsFilterInternalStatusPendingTask = payload
  },
  'OPTIONS_FILTER_CATEGORIES_PENDING_TASK' (state, payload) {
    state.session.optionsFilterCategoriesPendingTask = payload
  },
  'RADIO_OPTION_PENDING_TASK' (state, payload) {
    state.session.radioOption = payload
  },   

  // Factura o Facturas en Session
  'INVOICE_NOTE_IDS_STATE' (state, payload) {
    state.session.invoiceNoteIdsPendingTask = payload
  },

  'PROJECT_NAME_PENDING_STATE' (state, payload) {
    state.session.projectNamependingTask = payload
  },

  // Caratúla en sesión
  'HAS_COVER_STATE' (state, payload) {
    state.session.hasCoverPendingTask = payload
  },

  // Columnas Tabla  Tareas pendientes
  'IS_SHOW_BUYER_PENDING_TASK' (state, payload) {
    state.local.isShowBuyerPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowBuyerPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_CENTERS_PENDING_TASK' (state, payload) {
    state.local.isShowBuyerCentersPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowBuyerCentersPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_PENDING_TASK' (state, payload) {
    state.local.isShowSellerPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowSellerPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_PENDING_TASK' (state, payload) {
    state.local.isShowNumPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowNumPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_PENDING_TASK' (state, payload) {
    state.local.isShowDateIssuePendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowDateIssuePendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_PENDING_TASK' (state, payload) {
    state.local.isShowDateCreationPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowDateCreationPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_IMPORT_PENDING_TASK' (state, payload) {
    state.local.isShowImportPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowImportPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CURRENCY_PENDING_TASK' (state, payload) {
    state.local.isShowCurrencyPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowCurrencyPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_PENDING_TASK' (state, payload) {
    state.local.isShowStatusPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowStatusPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEPTION_METHOD_PENDING_TASK' (state, payload) {
    state.local.isShowReceptionMethodPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowReceptionMethodPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_IS_PENDING_TASK' (state, payload) {
    state.local.isShowIsPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowIsPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_INTERNAL_PENDING_TASK' (state, payload) {
    state.local.isShowStatusInternalPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowStatusInternalPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_REGISTER_NUMBER_PENDING_TASK' (state, payload) {
    state.local.isShowRegisterNumberPendingTask = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.tareaspendientes.isShowRegisterNumberPendingTask = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
